import { Fragment } from 'react'
import MenuRoutes from './Routes';

function App() {

  return (
    <Fragment>
      <MenuRoutes />
    </Fragment>
  );
}

export default App;
